import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MediaPlayer from 'components/Shared/MediaPlayer/MediaPlayer';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import Loader from 'components/Loader/Loader';
import VisibilitySensor from 'react-visibility-sensor';

import styles from './CollectionSinglePage.module.scss';

export default class CollectionSinglePage extends Component {
  static propTypes = {
    owner: PropTypes.object.isRequired,
    collection: PropTypes.array.isRequired,
    onClose: PropTypes.func,
    loadMore: PropTypes.func,
    loading: PropTypes.bool,
    scrollTo: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      scrollTo: props.scrollTo ? props.scrollTo : null,
      notLoaded: props.collection.map((project) => {
        return project.id;
      }),
    };
  }

  componentDidMount() {
    const element = document.getElementsByClassName(
      'collection-content-wrapper'
    )[0];
    element.addEventListener('scroll', this.handleScroll.bind(this));

    document.body.addEventListener('keydown', this.handleKeyDown.bind(this));

    document.getElementsByTagName('body')[0].classList.add('no-scroll');

    if (this.state.scrollTo) {
      this.handleVisibilityChange(this.state.scrollTo, false);
    }
  }

  componentDidUpdate() {
    if (this.state.scrollTo) {
      if (this.state.notLoaded.length <= 0) {
        setTimeout(() => {
          this.setState({ scrollTo: null }); // eslint-disable-line react/no-did-update-set-state
        }, 1000);
      }
    }
  }

  componentWillUnmount() {
    const element = document.getElementsByClassName(
      'collection-content-wrapper'
    )[0];
    element.removeEventListener('scroll', this.handleScroll.bind(this));

    document.body.removeEventListener('keydown', this.handleKeyDown.bind(this));

    document.getElementsByTagName('body')[0].classList.remove('no-scroll');
  }

  handleScroll(event) {
    const distanceFromBottom =
      event.target.scrollHeight -
      event.target.scrollTop -
      event.target.clientHeight;

    if (distanceFromBottom < 100 && !this.props.loading) {
      this.props.loadMore();
    }
  }

  handleVisibilityChange() {
    if (this.state.scrollTo) {
      const element = document.getElementById('project-' + this.state.scrollTo);
      if (element) {
        element.scrollIntoView();
      }
    }
  }

  handleKeyDown(event) {
    // if escape pressed
    if (event.keyCode === 27 && this.props.onClose) {
      this.props.onClose();
    }
  }

  handleMediaLoad(id) {
    const notLoaded = this.state.notLoaded;
    const index = notLoaded.indexOf(id);

    if (index > -1) {
      notLoaded.splice(index, 1);
    }

    this.setState({ notLoaded });
  }

  render() {
    const { owner, collection, onClose } = this.props;

    return (
      <div>
        <div className={styles.overlay} />
        <div className={styles.wrapper}>
          <div className={styles.heading}>
            <div className={styles.userDetails}>
              {owner.displayname} @{owner.username}
            </div>
            <div
              className={styles.closeButton}
              onClick={() => (onClose ? onClose() : null)}
            >
              <SvgIcon icon="close" color="#fff" size="30" />
            </div>
          </div>
          <hr />
          <div
            className={'collection-content-wrapper ' + styles.contentWrapper}
          >
            <div className={styles.content}>
              {collection.map((project) => {
                return (
                  <VisibilitySensor
                    key={project.id}
                    onChange={this.handleVisibilityChange.bind(this)}
                  >
                    <div id={'project-' + project.id}>
                      <div className={styles.media}>
                        <MediaPlayer
                          project={project}
                          zoom={false}
                          onLoad={this.handleMediaLoad.bind(this, project.id)}
                          staffPicks={false}
                        />
                      </div>
                      <div className={styles.details}>
                        <p className="mt" style={{ color: 'white' }}>
                          {project.title}
                        </p>
                        <p className="mb" style={{ color: 'white' }}>
                          {project.description}
                        </p>
                      </div>
                      <hr />
                    </div>
                  </VisibilitySensor>
                );
              })}
            </div>
          </div>
          {this.props.loading ? (
            <div className={styles.loader}>
              <Loader loading />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
